import React from 'react';
import Select from 'react-select';
import { Props } from 'react-select/lib/Select';

export interface OptionTypeBase {
  label: string;
  value: string;
}

/**
 * Wrapped React Select component for consistent styling
 */
const BzSelect = (props: Props) => {
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: '20px',
      height: 'calc(1.28em + .75rem + 2px)',
      border: '1px solid #c8d1e0',
      cursor: 'pointer',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      marginTop: '-4px',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      paddingTop: '0',
      paddingBottom: '0',
    }),
    option: (provided: any) => ({
      ...provided,
      cursor: 'pointer',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      minHeight: '1px',
      paddingBottom: '2px',
      top: '45%',
    }),
    //Fixes overflow problem with our custom radio buttons
    menu: styles => ({ ...styles, zIndex: 999 }),
  };

  return <Select {...props} styles={customStyles} />;
};

export default BzSelect;
